export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 rounded-2xl bg-primary-500 p-8 md:p-10">
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-background-50">
              随时随地，畅享腐漫
            </h2>
            <p className="mt-3 text-sm md:text-base text-primary-100 leading-relaxed">
              腐漫画网完美适配手机、平板与电脑，无需下载安装任何应用，打开浏览器即可沉浸式追漫。下拉式阅读设计让移动端体验同样顺滑流畅，通勤、午休、睡前，随时随地翻开属于你的精彩故事。
            </p>
            <div className="mt-5 flex flex-wrap items-center justify-center md:justify-start gap-3">
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50/20 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/30 transition-colors">
                <i className="ri-computer-line"></i>
                桌面端
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50/20 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/30 transition-colors">
                <i className="ri-smartphone-line"></i>
                移动端
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50/20 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/30 transition-colors">
                <i className="ri-tablet-line"></i>
                平板端
              </span>
            </div>
          </div>

          <div className="flex-shrink-0 w-32 h-32 md:w-40 md:h-40 flex items-center justify-center rounded-2xl bg-background-50/15">
            <i className="ri-smartphone-line text-5xl md:text-6xl text-background-50 w-14 h-14 md:w-16 md:h-16 flex items-center justify-center"></i>
          </div>
        </div>
      </div>
    </section>
  );
}